import { memo } from 'react';
import map from 'lodash/map';

import LeftPanelMenuItem from 'components/LeftPanel/LeftPanelMenuItem';
import useLeftPanelMenus from 'hooks/useLeftPanelMenus';
import withLocation from 'hocs/withLocation';

import { leftPanelMenuClasses } from './styled';

const LeftPanelMenu = () => {
  const { menus } = useLeftPanelMenus();

  return (
    <div className={leftPanelMenuClasses}>
      {map(menus, (menu, i) =>
        <div key={i}>
          {map(menu, (item, index) => <LeftPanelMenuItem key={index} {...item} />)}
        </div>)}
    </div>
  );
};

export default withLocation(memo(LeftPanelMenu));
